import React from 'react';
import './benefitCard.css'
import C2wSuperxLogoHolder from './logoHolder';

function C2wSuperxBenefitCard( { obj } ) {
  return (
    <div className='C2wSuperxBenefitCard_ctn'>
        <C2wSuperxLogoHolder className={'C2wSuperxLogoHolder_ctn'}  svgLogo={obj?.svgLogo} bgColor={obj?.bgColor}  />
        <div className='C2wSuperxBenefitCard_ctn_para'>
            <div className='C2wSuperxBenefitCard_heading'>{obj?.heading}</div>
            <div className='C2wSuperxBenefitCard_Subheading'>{obj?.infoPara}</div>
        </div>
    </div>
  )
}

export default C2wSuperxBenefitCard;
